import { setAccessToken } from "tbme/clientAdapter";
import { currentUser } from "tbme/localState";
import { ProfileContext } from "../types";

export class CurrentUserContextError extends Error {}

/**
 * Update currentUser variable from identity object set by visualforce page.
 */
export const setCurrentUserState = ({ cuid, identity }: ProfileContext) => {
  if (!cuid || !identity) {
    currentUser(null);
    return;
  }

  const { name, ProfilePictureUrl, backgroundImageUrl } = identity;

  if (!name || !ProfilePictureUrl || !backgroundImageUrl) {
    throw new CurrentUserContextError(
      `Invalid context provided for currentUser.`
    );
  }

  setAccessToken(identity.access_token || "");

  currentUser({
    id: cuid,
    fullName: name,
    avatarUrl: ProfilePictureUrl,
    backgroundImageUrl: backgroundImageUrl,
  });
};
